module.exports = __webpack_public_path__ + "static/media/1.ee2aab76.webp";